var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#7DCFED}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_644682848"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M8000000 -12c-4417998,0 -8000012,3582014 -8000012,8000012 0,4417998 3582014,8000012 8000012,8000012 4417998,0 8000012,-3582014 8000012,-8000012 0,-4417998 -3582014,-8000012 -8000012,-8000012zm999981 12000018c0,552000 -448016,999981 -999981,999981 -551965,0 -999981,-448016 -999981,-999981l0 -5000022c0,-552000 448016,-999981 999981,-999981 551965,0 999981,448016 999981,999981l0 5000022zm-999981 -6984003c-552000,0 -999981,-448016 -999981,-999993 0,-551965 448016,-999981 999981,-999981 551965,0 999981,448016 999981,999981 0,551977 -447981,999993 -999981,999993z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.1f7479ccf4269fd50a72b2292d8992e6.svg";
export { ForwardRef as ReactComponent };